import {
  IServerSideDatasource,
  IServerSideGetRowsParams,
  IServerSideGetRowsRequest,
} from '@ag-grid-community/core';

import { IDataQueryResponse } from '../data-query';
import { sanitizeFilterModel } from '../utils';

export const generateDatasource = (
  source: string,
  getData: (source: string, request: IServerSideGetRowsRequest) => Promise<IDataQueryResponse>,
): IServerSideDatasource => {
  const getRequest = (params: IServerSideGetRowsParams): IServerSideGetRowsRequest => {
    const formattedFilterModels = sanitizeFilterModel(params.request.filterModel, params.columnApi);

    return {
      ...params.request,
      filterModel: {
        ...params.request.filterModel,
        ...formattedFilterModels,
      },
    };
  };

  const setResponse = (rows, params: IServerSideGetRowsParams) => {
    if (params.request.rowGroupCols.length === 0) return rows;
    // Null values are not being grouped in agGrid
    return rows.map((row) => {
      params.request.rowGroupCols.forEach((rowGroupCol) => {
        if (row[rowGroupCol.field] === null || row[rowGroupCol.field] === undefined) {
          row[rowGroupCol.field] = '';
        }
      });

      return row;
    });
  };

  return {
    getRows(params: IServerSideGetRowsParams) {
      getData(source, getRequest(params))
        .then((response: IDataQueryResponse) => {
          params.successCallback(setResponse(response.rows, params), response.lastRow);
        })
        .catch((error) => {
          console.error(error);
          params.failCallback();
        });
    },
  };
};
